import { APP_TABS, AppTab, tabPath } from '../router';
import { renderDevices } from '../pages/devices';
import { renderFamily } from '../pages/family';
import { renderSupport } from '../pages/support';
import { el } from '../ui/dom';

/** Compact nav glyphs from Remindo_WebApp_v7_topnav.html */
const NAV_ICONS: Record<AppTab, string> = {
  devices:
    '<svg class="nav-svg" viewBox="0 0 24 24" aria-hidden="true"><rect class="paper" x="3.5" y="5" width="17" height="14" rx="2"/><circle class="accent-green" cx="8" cy="12" r="2.2"/><path class="thin" d="M12 9h5M12 12h5M12 15h3"/></svg>',
  members:
    '<svg class="nav-svg" viewBox="0 0 24 24" aria-hidden="true"><path class="accent-red" d="M3 10.8L12 2.9l9 7.9-1.7 1.9L12 6.2l-7.3 6.5L3 10.8z"/><path class="paper" d="M5.4 11.5v9.1h13.2v-9.1L12 5.7 5.4 11.5z"/><path class="accent-blue" d="M8 13.1h3.1v3.6H8z"/><path class="accent-green" d="M12.9 13.1H16v7.5h-3.1z"/><path class="thin" d="M11.9 20.6H3.8M20.2 20.6h-2.5"/></svg>',
  help:
    '<svg class="nav-svg" viewBox="0 0 24 24" aria-hidden="true"><path class="paper" d="M5.2 5.3h13.6c1.1 0 2 .9 2 2v7.4c0 1.1-.9 2-2 2h-6.9l-4.3 3.5v-3.5H5.2c-1.1 0-1.9-.9-1.9-2V7.3c0-1.1.8-2 1.9-2z"/><circle class="ink" cx="8.3" cy="11" r=".9"/><circle class="ink" cx="12" cy="11" r=".9"/><circle class="ink" cx="15.7" cy="11" r=".9"/></svg>',
};

export async function renderAppShell(root: HTMLElement, tab: AppTab): Promise<void> {
  root.innerHTML = '';
  const shell = el('div', { className: 'app-shell' });

  const sidebar = el('aside', { className: 'sidebar' });
  const brand = el('div', { className: 'sb-brand' }, [
    el('span', { className: 'bn' }, 'remindo'),
  ]);
  sidebar.append(brand);

  for (const t of APP_TABS) {
    const btn = el('button', {
      className: `nav-item${t.id === tab ? ' on' : ''}`,
      type: 'button',
    }) as HTMLButtonElement;
    const ic = el('span', { className: 'ni-ic' });
    ic.innerHTML = NAV_ICONS[t.id];
    btn.append(ic, el('span', {}, t.label));
    btn.onclick = () => {
      window.history.pushState({}, '', tabPath(t.id));
      window.dispatchEvent(new PopStateEvent('popstate'));
    };
    sidebar.append(btn);
  }

  const main = el('div', { className: 'main' });
  const page = el('main', { className: 'page', id: 'page-content' });
  main.append(page);
  shell.append(sidebar, main);
  root.append(shell);

  const loaders: Record<AppTab, (el: HTMLElement) => Promise<void>> = {
    devices: renderDevices,
    members: renderFamily,
    help: renderSupport,
  };
  await loaders[tab](page);
}
